export default {
    operators: {
        $eq: {
            label: 'Gleich'
        },
        $ne: {
            label: 'Nicht gleich'
        },
        $gte: {
            label: 'Größer als oder gleich'
        },
        $gt: {
            label: 'Größer als'
        },
        $lte: {
            label: 'Kleiner als oder gleich'
        },
        $lt: {
            label: 'Kleiner als'
        },
        $in: {
            label: 'Enthält'
        },
        $nin: {
            label: 'Enthält nicht'
        },
        $size: {
            label: 'Anzahl'
        },
    },
    filters: [
        {
            label: 'Zielgruppen',
            name: 'targetgroups',
            entity(event = {targetgroups: []}, id){
                let ret = {}
                ret.origin = Object.assign({}, event.targetgroups.find(w => id == w.id))
                ret.label = ret.origin.label
                return ret
            },
            entities(event = {targetgroups: []}){
                let ret = []
                event.targetgroups.forEach(w => {
                    ret.push({label:w.label,id:w.id})
                })
                return ret
            },
            operators: [
                {
                    type: '$in',
                    name: 'registered',
                    icons: ['bullseye-arrow','check'],
                    label: 'enthalten in',
                    filter(event, user, entity = '', value = false){
                        return event.targetgroups.find(w => entity == w.id).ids.includes(user.id)
                    }
                },
                {
                    type: '$nin',
                    name: 'notRegistered',
                    icons: ['bullseye-arrow','times'],
                    label: 'nicht enthalten in',
                    filter(event, user, entity = '', value = false){
                        return !event.targetgroups.find(w => entity == w.id).ids.includes(user.id)
                    }
                }
            ]
        },
        {
            label: 'Rückmeldung',
            name: 'reply',
            entity(event, id){
                let ret = {origin: {}}
                ret.origin = Object.assign({}, this.entities(null).find(e => e.id === id))

                ret.label = ret.origin.label
                return ret
            },
            entities(event){
                return [
                    {
                        label: 'Zugesagt',
                        id: 'yes'
                    },
                    {
                        label: 'Abgesagt',
                        id: 'no'
                    },
                    {
                        label: 'keine Rückmeldung',
                        id: 'none'
                    }
                ]
            },
            operators: [
                {
                    type: '$eq',
                    name: 'attending',
                    icons: ['comment-dots','check'],
                    entities: false,
                    label: 'Zusage',
                    filter(event, user, entity = '', value = false){
                        return user.data._attending === 'yes'
                    }
                },
                {
                    type: '$eq',
                    name: 'notAttending',
                    icons: ['comment-dots','times'],
                    entities: false,
                    label: 'Absage',
                    filter(event, user, entity = '', value = false){
                        return user.data._attending === 'no'
                    }
                },
                {
                    type: '$eq',
                    name: 'attendingOrNotAttending',
                    icons: ['comment-dots','check','times'],
                    entities: false,
                    label: 'Zu- oder Absage',
                    filter(event, user, entity = '', value = false){
                        return user.data._attending === 'yes' || user.data._attending === 'no'
                    }
                },
                {
                    type: '$eq',
                    name: 'noReply',
                    icons: ['comment-dots','question'],
                    entities: false,
                    label: 'keine Rückmeldung',
                    filter(event, user, entity = '', value = false){
                        return user.data._attending !== 'yes' && user.data._attending !== 'no'
                    }
                }
            ]
        },
        {
            label: 'Gastdaten',
            name: 'fields',
            entity(event = {fields: {editable: []}}, id){
                let ret = {origin: {}}

                if(typeof event.fields.editable.find(f => f.id === id) !== 'undefined'){
                    ret.origin = Object.assign({}, event.fields.editable.find(f => f.id === id))
                }else if(typeof event.fields.shown.find(f => f.id === id) !== 'undefined'){
                    ret.origin = Object.assign({}, event.fields.shown.find(f => f.id === id))
                }else if(typeof event.fields.available.find(f => f.id === id) !== 'undefined'){
                    ret.origin = Object.assign({}, event.fields.available.find(f => f.id === id))
                }

                ret.label = ret.origin.name
                return ret
            },
            entities(event = {fields: {editable: []}}){
                let ret = []
                event.fields.editable.forEach(w => {
                    ret.push({label:w.name,id:w.id})
                })
                event.fields.shown.forEach(w => {
                    ret.push({label:w.name,id:w.id})
                })
                event.fields.available.forEach(w => {
                    ret.push({label:w.name,id:w.id})
                })
                return ret
            },
            operators: [
                {
                    type: '$eq',
                    name: 'contains',
                    value: 'string',
                    default: '',
                    icons: ['user-tag'],
                    label: 'enthält',
                    filter(event, user, entity = '', value = false){
                        let patt = new RegExp(value, "i");
                        return patt.test(user['field_'+entity])
                    }
                }
            ]
        },
        {
            label: 'Gast - zusätzliche Infos',
            name: 'additionalInfos',
            entity(event = {guests: {guestFields: []}}, id){
                let ret = {origin: {}}

                ret.origin = Object.assign({}, event.guests.guestFields.find(f => f.name === id))

                ret.label = ret.origin.label
                return ret
            },
            entities(event = {guests: {guestFields: []}}){
                let ret = []
                let allowedTypes = ['misc', 'enum', 'multiline', 'email']
                event.guests.guestFields.forEach(w => {
                    if(allowedTypes.includes(w.type)) ret.push({label:w.label,id:w.name})
                })
                return ret
            },
            operators: [
                {
                    type: '$eq',
                    name: 'contains',
                    value: 'string',
                    default: '',
                    icons: ['user-cog'],
                    label: 'enthält',
                    filter(event, user, entity = '', value = false){
                        let patt = new RegExp(value, "i");
                        if(typeof user.data.additionalInfo !== 'object') return false
                        return patt.test(user.data.additionalInfo['info_'+entity])
                    }
                }
            ]
        },
        {
            label: 'Teilnahme',
            name: 'workshopsRegistered',
            entity(event = {transfers: []}, id){
                let ret = {}
                ret.origin = Object.assign({}, event.workshops.find(w => id == w.id))
                ret.label = ret.origin.name
                return ret
            },
            entities(event = {workshops: []}){
                let ret = []
                event.workshops.forEach(w => {
                    if(w.mandatory === true) return
                    ret.push({label:w.name,id:w.id})
                })
                return ret
            },
            operators: [
                {
                    type: '$in',
                    name: 'registered',
                    icons: ['user-check'],
                    label: 'Teilgenommen',
                    filter(event, user, entity = '', value = false){
                        return user.data.checkin['workshop_' + entity + '_checkin'] == true
                    }
                },
                {
                    type: '$nin',
                    name: 'notRegistered',
                    icons: ['user-times'],
                    label: 'Nicht teilgenommen',
                    filter(event, user, entity = '', value = false){
                        return user.data.checkin['workshop_' + entity + '_checkin'] != true
                    }
                }
            ]
        },
        {
            label: 'Veranstaltung',
            name: 'workshops',
            entity(event = {transfers: []}, id){
                let ret = {}
                ret.origin = Object.assign({}, event.workshops.find(w => id == w.id))
                ret.label = ret.origin.name
                return ret
            },
            entities(event = {workshops: []}){
                let ret = []
                event.workshops.forEach(w => {
                    if(w.mandatory === true) return
                    ret.push({label:w.name,id:w.id})
                })
                return ret
            },
            operators: [
                {
                    type: '$in',
                    name: 'registered',
                    icons: ['user-check'],
                    label: 'Angemeldet für',
                    filter(event, user, entity = '', value = false){
                        return user.data.workshops['workshop_' + entity + '_registered'] == true
                    }
                },
                {
                    type: '$nin',
                    name: 'notRegistered',
                    icons: ['user-times'],
                    label: 'Nicht angemeldet für',
                    filter(event, user, entity = '', value = false){
                        return user.data.workshops['workshop_' + entity + '_registered'] != true
                    }
                }
            ]
        },
        {
            label: 'Transfers',
            name: 'transfers',
            entity(event = {transfers: []}, id){
                let ret = {}
                ret.origin = Object.assign({}, event.transfers.find(w => id == w.id))
                ret.label = ret.origin.name
                return ret
            },
            entities(event = {transfers: []}){
                let ret = []
                event.transfers.forEach(w => {
                    ret.push({label:w.name,id:w.id})
                })
                return ret
            },
            operators: [
                {
                    type: '$in',
                    name: 'registered',
                    icons: ['check'],
                    label: 'Angemeldet für',
                    filter(event, user, entity = '', value = false){
                        return user.data.transfers['transfer_' + entity + '_registered'] == true
                    }
                },
                {
                    type: '$nin',
                    name: 'notRegistered',
                    icons: ['times'],
                    label: 'Nicht angemeldet für',
                    filter(event, user, entity = '', value = false){
                        return user.data.transfers['transfer_' + entity + '_registered'] != true
                    }
                }
            ]
        },
        {
            label: 'Unterbringung',
            name: 'accommodations',
            entity(event = {accommodations: []}, id){
                let ret = {}
                ret.origin = Object.assign({}, event.accommodations.find(w => id == w.id))
                ret.label = ret.origin.name
                return ret
            },
            entities(event = {accommodations: []}){
                let ret = []
                event.accommodations.forEach(w => {
                    ret.push({label:w.name,id:w.id})
                })
                return ret
            },
            operators: [
                {
                    type: '$in',
                    name: 'registered',
                    icons: ['check'],
                    label: 'Angemeldet für',
                    filter(event, user, entity = '', value = false){
                        return user.data.accommodations['accommodation_' + entity + '_registered'] == true
                    }
                },
                {
                    type: '$nin',
                    name: 'notRegistered',
                    icons: ['times'],
                    label: 'Nicht angemeldet für',
                    filter(event, user, entity = '', value = false){
                        return user.data.accommodations['accommodation_' + entity + '_registered'] != true
                    }
                }
            ]
        },
        {
            label: 'Begleitung',
            name: 'companyInfo',
            entity(event = {guests: {companiesFields: []}}, id){
                let ret = {}
                ret.origin = Object.assign({}, event.guests.companiesFields.find(w => id == w.name))
                ret.label = ret.origin.label
                return ret
            },
            entities(event = {guests: {companiesFields: []}}){
                let ret = []
                event.guests.companiesFields.forEach(w => {
                    ret.push({label:w.label,id:w.name})
                })
                return ret
            },
            operators: [
                {
                    type: '$eq',
                    name: 'countEqual',
                    value: 'number',
                    default: 0,
                    entities: false,
                    icons: ['equals'],
                    label: 'Anzahl gleich',
                    filter(event, user, entity = '', value = false){
                            if(Array.isArray(user.data.companies)) return user.data.companies.length === value
                            return false
                    }
                },
                {
                    type: '$gt',
                    name: 'countGreater',
                    value: 'number',
                    default: 0,
                    entities: false,
                    icons: ['greater-than'],
                    label: 'Anzahl größer als',
                    filter(event, user, entity = '', value = false){
                            if(Array.isArray(user.data.companies)) return user.data.companies.length > value
                            return false
                    }
                },
                {
                    type: '$gte',
                    name: 'countGreaterEqual',
                    value: 'number',
                    default: 0,
                    entities: false,
                    icons: ['greater-than-equal'],
                    label: 'Anzahl größer gleich',
                    filter(event, user, entity = '', value = false){
                            if(Array.isArray(user.data.companies)) return user.data.companies.length >= value
                            return false
                    }
                },
                {
                    type: '$lt',
                    name: 'countLess',
                    value: 'number',
                    default: 0,
                    entities: false,
                    icons: ['less-than'],
                    label: 'Anzahl kleiner als',
                    filter(event, user, entity = '', value = false){
                            if(Array.isArray(user.data.companies)) return user.data.companies.length < value
                            return false
                    }
                },
                {
                    type: '$lte',
                    name: 'countLessEqual',
                    value: 'number',
                    default: 0,
                    entities: false,
                    icons: ['less-than-equal'],
                    label: 'Anzahl kleiner gleich',
                    filter(event, user, entity = '', value = false){
                            if(Array.isArray(user.data.companies)) return user.data.companies.length <= value
                            return false
                    }
                }
            ]
        },
    ]
}
